import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		root: {
			'& > *': {
				margin: 0,
			},
		},
		input: {
			display: 'none',
		},
		button: {
			background: 'white',
			color: 'black',
			border: '1px solid #7FD6DD',
			borderRadius: 20,
			borderTopRightRadius: 0,
			borderBottomRightRadius: 0,
			padding: '.5rem 2rem',
		},
		listItems: {
			listStyleType: 'none',
			padding: '1rem',
			background: 'white',
			borderRadius: '20px',
			fontFamily: 'Poppins',
			boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
			[theme.breakpoints.down('xs')]: {
				// background: '#F1F6FA',
				// padding: '2rem !important',
				// fontSize: '16px',
			},
		},
		item: {
			'&:hover': { background: '#7FD6DD', padding: '0.3rem', cursor: 'pointer' },
		},
		iconButton: {
			background: 'white',
			padding: '.5rem .8rem',
			borderRadius: 20,
			borderTopLeftRadius: 0,
			borderBottomLeftRadius: 0,
			color: 'black',
			border: '1px solid #7FD6DD',
			borderLeft: 'none',
		},
	}),
);
